import { useCatalogFilter } from '../../context/CatalogFilterContext';
import { UseCatalogFilterParamsReturnType } from '../../types';

export const useCatalogFilterParams = (): UseCatalogFilterParamsReturnType => {
    return useCatalogFilter();
};

export default useCatalogFilterParams;